export default __webpack_public_path__ + "static/media/GroupedBarChart.eb182145.svg";